

























import Vue from 'vue';
import store, { KanriInvoiceStore } from "../services/KanriInvoiceStore";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import { t } from "@/plugins/i18n";

type KanriItem = any;
type KanriInvoice = any;

interface Data {
    store: KanriInvoiceStore;
    kanriItems: KanriItem[];
}

export default Vue.extend<Data, {}, {}, {}>({
    components: {
        MoneyDisplay,
    },

    props: {
        head: { type: Object as () => KanriInvoice }
    },

    data() {
        return {
            store,
            kanriItems: [],
        }
    },

    async beforeMount() {
        this.kanriItems = await this.store.getItemsByHead(Number(this.$props.head.id));
    },

    computed: {
        columns: () => [
            {
                field: "id",
                title: t("Azonosito")
            },
            {
                field: "itemName",
                title: t("Nev")
            },
            // {
            //     field: "positionNo",
            //     title: "Pozíció"
            // },
            {
                field: "positionType",
                title: t("Tipus")
            },
            {
                field: "docNo",
                title: t("Dokumentum")
            },
            {
                field: "vin",
                title: t("Alvazszam")
            },
            // {
            //     field: "amount",
            //     title: "Totál?"
            // },
            {
                field: "netto",
                title: t("Netto"),
                cell: "nettoTemplate",
                headerClassName: "right_text"
            },
            {
                field: "vat",
                title: t("Afa"),
                cell: "vatTemplate",
                headerClassName: "right_text"
            },
            {
                field: "total",
                title: t("Brutto"),
                cell: "totalTemplate",
                headerClassName: "right_text"
            },
        ]
    },
})
